import { ResourceType } from '../../shared/resource-type';

export const WORKFLOWITEM = new ResourceType('workflowitem');
